module.exports = "<div class=col-xs-4> <a href=# class=\"base-btn purple-btn v2-btn q-pull-right add-facility-cancel-btn\"> Cancel </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/addressBook/html/createOrganization/addFacilityButtons.html
// module id = 1176
// module chunks = 1